export type ReadingSize = "compact" | "balanced" | "generous";
export type ReadingTheme = "paper" | "night";

type DevicePreferenceStorage = Pick<Storage, "getItem">;

export type StoredDevicePreferences = {
  currentReadingId: string | null;
  expressionStudyId: string | null;
  expressionStanceId: string | null;
  pronunciationVoiceUri: string;
  readingSize: ReadingSize;
  theme: ReadingTheme;
};

export function readStoredDevicePreferences(
  storage: DevicePreferenceStorage,
): StoredDevicePreferences {
  const rememberedSize = storage.getItem("verbalore-reading-size");
  const rememberedTheme =
    storage.getItem("verbalore-theme")
    || storage.getItem("weight-of-words-theme");

  return {
    currentReadingId: storage.getItem("verbalore-current-reading"),
    expressionStudyId: storage.getItem("verbalore-expression-study"),
    expressionStanceId: storage.getItem("verbalore-expression-stance"),
    pronunciationVoiceUri:
      storage.getItem("verbalore-pronunciation-voice") || "default",
    readingSize:
      rememberedSize === "compact" || rememberedSize === "generous"
        ? rememberedSize
        : "balanced",
    theme: rememberedTheme === "night" ? "night" : "paper",
  };
}
